module.exports = __webpack_public_path__ + "img/icon-lzc.1e510de9.png";